import React, { ReactNode, useState } from "react";
import { QueryClient, QueryClientProvider } from "@origin-digital/query";

export const QueryProvider = ({ children }: { children: ReactNode }) => {
  const [client] = useState(() => new QueryClient());
  return <QueryClientProvider client={client}>{children}</QueryClientProvider>;
};
